import { observer } from 'mobx-react-lite';
import React, { FC} from 'react';


const SocialObjects: FC<any> = (() => {

    return (
        <div className="w-100 h-100 p-0 position-relative end-0">
            {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
            <iframe src="https://www.google.com/maps/d/embed?mid=1EudQEoXFgS_TOi1TPEroEquKimyka_g&ehbc=2E312F"
                    className="w-100 h-100 border-0" />
        </div>
    )
});

export default observer(SocialObjects);